// extracted by mini-css-extract-plugin
module.exports = {"circle":"PointsLine_circle__2gDPm","circle-ring":"PointsLine_circle-ring__35oQN"};